import { Routes, Route } from "react-router";

import {About, Home, Image, Latest} from "./pages";

// Import the app-wide CSS file to load the styling here.
// eslint-disable-next-line no-unused-vars
import photoappCss from './photoapp.css';

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/latest" element={<Latest />} />
      <Route path="/image/:imageId" element={<Image />} />
    </Routes>
  );
}

export default Router;
